import unboundActions from "domain/core/actions";
import { useActions } from "re-reduced";
import React, { useCallback } from "react";
import { MLink } from "ui/components/StyledComponents";

type BackButtonProps = {
  formStep: string;
};

export const BackButton: React.FC<BackButtonProps> = ({ formStep }) => {
  const actions = useActions(unboundActions);

  const handleNavigateBack = useCallback(() => {
    actions.setCurrentFormStep(formStep);
  }, [formStep]);

  return (
    <MLink id="link-previous-form-step" onClick={handleNavigateBack}>
      Back to previous step
    </MLink>
  );
};
